import { render, staticRenderFns } from "./Offshore.vue?vue&type=template&id=70094785&"
import script from "./Offshore.vue?vue&type=script&lang=js&"
export * from "./Offshore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports